import type { EmailTemplateListItem } from '../../types/workspace.types';

interface Props {
  item: EmailTemplateListItem;
  onEdit: (templateType: string) => void;
  onReset: (templateType: string) => void;
}

function getSourceBadgeClass(source: EmailTemplateListItem['source']): string {
  switch (source) {
    case 'TenantOverride':
      return 'bg-green-100 text-green-700';
    case 'GlobalDefault':
      return 'bg-blue-100 text-blue-700';
    case 'BuiltInDefault':
      return 'bg-gray-100 text-gray-700';
    default:
      return 'bg-gray-100 text-gray-700';
  }
}

const EmailTemplateRow: React.FC<Props> = ({ item, onEdit, onReset }) => {
  return (
    <tr className="border-b border-gray-100 hover:bg-gray-50">
      <td className="py-3 px-4 text-sm text-gray-900 whitespace-nowrap">
        {item.displayName}
      </td>
      <td className="py-3 px-4">
        <span
          className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${getSourceBadgeClass(
            item.source
          )}`}
        >
          {item.source === 'TenantOverride'
            ? 'Tenant Override'
            : item.source === 'GlobalDefault'
            ? 'Global Default'
            : 'Built-in Default'}
        </span>
      </td>
      <td className="py-3 px-4 text-right space-x-2 whitespace-nowrap">
        <button
          type="button"
          onClick={() => onEdit(item.templateType)}
          className="px-3 py-1.5 text-xs md:text-sm font-medium text-white bg-primary-500 rounded-md hover:bg-primary-700"
        >
          Edit
        </button>
        {item.hasOverride && (
          <button
            type="button"
            onClick={() => onReset(item.templateType)}
            className="px-3 py-1.5 text-xs md:text-sm font-medium text-red-600 border border-red-200 rounded-md hover:bg-red-50"
          >
            Reset
          </button>
        )}
      </td>
    </tr>
  );
};

export default EmailTemplateRow;
